<template>
    <div v-loading="loading">
        <div ref="chinaMap" :style="{ height: map_height, width: '100%' }"></div>
    </div>
</template>
  
<script>
import OrderCount from "~/services/OrderCount";
import echarts from "echarts";
import macarons from "~/assets/echart-map-themes/macarons";
import China from "echarts/map/js/china";
echarts.registerTheme("macarons", macarons);

export default {
    props:{
        params:{
            type: Object,
            required: true,
        },
        map_height:{
            type: String,
            default: '600px',
        }
    },
    data() {
        return {
            loading: false,
            count_data: null,
        };
    },
    created(){
        this.getData(this.params);
    },
    mounted() {
        
    },
    methods: {
        getData(params) {
            this.loading = true;
            OrderCount.getAreaMap(params).then((res) => {
                if (res.code == 0) {
                    //初始化地图
                    this.count_data = res.data;
                    this.initChart();
                }
                this.loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },
        initChart() {
            if (!this.count_data || this.count_data.length == 0) {
                return false;
            }
            const chartContainer = this.$refs.chinaMap;
            if (!chartContainer){
                return false;
            }
            const myChart = echarts.init(chartContainer, "macarons");
            const option = {
                title: {
                    text: "",
                    subtext: "提示：点击下方 👇 地图中 或 右侧 👉 表格中的地区进入该地区维度统计",
                    x: "center",
                    subtextStyle: {
                        color: '#85CE61'
                    }
                },
                tooltip: {
                show: true,
                formatter: function (params) {
                    let show_str = params.name;
                    if(params.data){
                        show_str += '-成交客户' + '<br/>';
                        // console.log("获取焦点：", params);
                        params.data.city_list.forEach(item => {
                            show_str += item.name + '：' + item.value + '<br/>';
                        });
                    }
                    return show_str;
                },
                },

                xAxis: {
                    type: "value",
                    scale: false,
                    position: "top",
                    splitNumber: 1,
                    boundaryGap: false,
                    splitLine: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        margin: 2,
                        textStyle: {
                            color: "#aaa",
                        },
                    },
                },
                yAxis: {
                    type: "category",
                    nameGap: 16,
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "#ddd",
                        },
                    },
                    axisTick: {
                        show: false,
                        lineStyle: {
                            color: "#ddd",
                        },
                    },
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            color: "#999",
                        },
                    },
                },

                legend: {
                    orient: "vertical",
                    x: "left",
                    data: ["iphoneX"],
                },

                dataRange: {
                    // min: 0,
                    // max: 5000,
                    x: "left",
                    y: "bottom",
                    text: ["最高", "最低"],
                    calculable: false,
                },

                // 工具条
                toolbox: {
                    show: false,
                    orient: "vertical",
                    x: "right",
                    y: "center",
                    feature: {
                        mark: { show: true },
                        dataView: { show: true, readOnly: false },
                        restore: { show: true },
                        saveAsImage: { show: true },
                    },
                },

                series: [
                {
                    name: "申请数",
                    type: "map",
                    mapType: "china",
                    roam: false,
                    selectedMode: "single",
                    itemStyle: {
                        normal: { label: { show: true } },
                        emphasis: { label: { show: true } },
                    },
                    data: this.count_data,
                },
                ],
            };
            myChart.setOption(option);
            myChart.on('click', params => {
                this.getDistrictChart(params.data);
            });
        },


        getDistrictChart(item) {
            // console.log('点击地区：', item);
            if(item !== undefined && Object.keys(item).length !== 0){
                this.$emit("change", item);
            }
        },
    },
};
</script>
  
<style>
/* 在这里添加样式 */
</style>
  


// WEBPACK FOOTER //
// src/views/count/echarts/chinaChart.vue